import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { RatingsDataService, RatingsColumnsService } from '../../../services';
import { Rating, RatingsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-rating-details',
  templateUrl: './rating-details.component.html',
  styleUrls: ['./rating-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class RatingDetailsComponent implements OnInit, OnDestroy {

  public rating: Rating = {};
  public ratings: Rating[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ratingsDataService: RatingsDataService,
    private ratingsColumnsService: RatingsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Rating - Details');
        this.getRating(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.rating !== 'undefined') {
      this.rating = this.dynamicDialogConfig.data.rating;
    }
    this.columns = this.ratingsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getRating(id: number): void {
    this.isLoading = true;
    this.ratingsDataService.getRating(id).subscribe((response: Rating|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.rating = response;
      }
    });
  }

  list() {
    this.router.navigate(['/ratings']);
  }

  add() {
    this.router.navigate(['/ratings/add']);
  }

  edit() {
    this.router.navigate(['/ratings/edit/' + this.rating.id]);
  }

}
@Component({
  selector: 'app-rating-details',
  templateUrl: './rating-details.component.html',
  styleUrls: ['./rating-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogRatingDetailsComponent extends RatingDetailsComponent {
}

